import { lazy } from 'react';
import { Route } from 'react-router-dom';

const SignIn = lazy(() => import("@/pages/auth/SignIn"));
const ResetPassword = lazy(() => import("@/pages/auth/ResetPassword"));
const ForgetPassword = lazy(() => import("@/pages/auth/ForgetPassword"));
const ConfirmForgetPassword = lazy(() => import("@/pages/auth/ConfirmForgetPassword"));
const VerifyMfa = lazy(() => import("@/pages/auth/VerifyMfa"));
const SetUpMfa = lazy(() => import("@/pages/auth/SetUpMfa"));
import AuthOutlet from '@/navigation/AuthOutlet';

const AuthRoutes = (
    <Route path="auth" element={<AuthOutlet />}>
    <Route index element={<SignIn />} />
    <Route path="setup-mfa" element={<SetUpMfa />} />
    <Route path="verify-mfa" element={<VerifyMfa />} />
    <Route path="reset-password" element={<ResetPassword />} />
    <Route path="forget-password" element={<ForgetPassword />} />
    <Route path="confirm-forget-password" element={<ConfirmForgetPassword />} />
  </Route>
)

export default AuthRoutes;